// extracted by mini-css-extract-plugin
export default {"starRating":"StarRating_starRating__z1v8c","starItem":"StarRating_starItem__NCMnp","active":"StarRating_active__YUIT-","inactive":"StarRating_inactive__+iO76"};